import { connect } from 'react-redux';
import ChecklistQuestions from "./ChecklistQuestions";
import { bindActionCreators } from 'redux';
import {
    fetchPmQues,
    pmSoftwareAnswer,
} from 'services/redux/maintenance/pmSities/action';
import { documentUploadUrl } from 'services/redux/fileUpload/action';

const mapStateToProps = (state) => ({
    pmChecklistQues: state.pmSitiesReducer.pmChecklistQues,
    pmSoftwareAnswerResponse: state.pmSitiesReducer.pmSoftwareAnswerResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            fetchPmQues,
            pmSoftwareAnswer,
            documentUploadUrl
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ChecklistQuestions);
